import script from "./AppTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./AppTooltip.vue?vue&type=style&index=0&id=a30ebfba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a30ebfba"]])

export default __exports__